"use strict";
exports.__esModule = true;
exports.createSession = exports.PROMOCODE_KEY = void 0;
var model_1 = require("../../basket/model");
exports.PROMOCODE_KEY = 'promoCode';
exports.createSession = function (payload) {
    if (payload === void 0) { payload = {}; }
    var basketSession = model_1.createBasketSession(payload.basket);
    return {
        sessionId: payload.sessionId,
        engineId: payload.engineId,
        groupId: payload.groupId,
        display: payload.display,
        context: payload.context,
        basket: basketSession,
        roomFilters: payload.roomFilters,
        hotelFilters: payload.hotelFilters,
        roomSortType: payload.roomSortType,
        hotelSortType: payload.hotelSortType,
        isMonoHotel: payload.isMonoHotel,
        defaultDistance: payload.defaultDistance
    };
};
//# sourceMappingURL=session.js.map